import { useLocation } from 'react-router-dom';
import { FELT_BG, C, anim } from './mobUI';
import { MobTabBar } from './MobTabBar';
import './mobMotion.css';

export function MobLayout({ children, openConnectModal }) {
  const { pathname } = useLocation();
  return (
    <div style={{ minHeight: '100dvh', background: FELT_BG, color: C.ink, paddingBottom: 'calc(58px + env(safe-area-inset-bottom, 0px))' }}>
      <div key={pathname} style={{ animation: anim('mob-screenin .34s ease') }}>{children}</div>
      <MobTabBar />
      {openConnectModal}
    </div>
  );
}
